import React, { useEffect, useState, useContext } from 'react';

import cookie from 'react-cookies';
import { useNavigate, useParams } from 'react-router-dom';

import './Home.css';

import BnplPageFlow from '../components/Bnpl/BnplPageFlow';
import PageForm from '../components/PageForm/PageForm';
import Layout from '../components/common/Layout';
import { getTenant } from '../config';
import { UserContext } from '../context/UserContext';
import { getApplication, createApplication } from '../service/api';
import rudderanalytics from '../service/rudderstack';

function Home() {
  const [isLoading, setLoading] = useState(true);
  const { id, loanProductId } = useParams();
  const { updateAppData } = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(() => {
    rudderanalytics.page('Home');

    async function startApplication() {
      setLoading(true);
      try {
        if (id) {
          if (loanProductId) {
            localStorage.setItem('loanProductId', loanProductId);
          }
          cookie.save('appId', id, { path: '/' });
          const res = await getApplication();
          if (res && res.data) {
            updateAppData(res.data);
          }
        } else {
          const res = await createApplication();
          if (res && res.data) {
            cookie.save('appId', res.data.id, { path: '/' });
            updateAppData(res.data);
            navigate(`/product/${res.data.loanProductId}/application/${res.data.id}`);
          }
        }
        setLoading(false);
      } catch (e) {
        console.error(e);
        updateAppData({});
        setLoading(false);
      }
    }
    startApplication();
  }, []);

  const renderForm = () => {
    if (getTenant() === 'lightrx') {
      return <BnplPageFlow />;
    }
    return !isLoading ? <PageForm /> : <div className="loading">Loading...</div>;
  };

  return <Layout>{renderForm()}</Layout>;
}

export default Home;
